import {AccountLayoutComponent} from './components/layout/account-layout.component';
import {AccountLoginIdpComponent} from './components/login-idp/account-login-idp.component';
import {AccountOauthCallbackComponent} from './components/oauth-callback/oauth-callback.component';
import {AuthGuard} from './guards/auth-guard.service';
import {AuthService} from './services/auth.service';
import {BavelAccountRoutingModule} from './bavel-account-routing.module';
import {BavelEncryptionModule} from '@shared/encryption/bavel-encryption.module';
import {BavelSharedModule} from '@shared/shared.module';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    BavelAccountRoutingModule,
    BavelEncryptionModule,
    BavelSharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [
    AccountLayoutComponent,
    AccountOauthCallbackComponent,
    AccountLoginIdpComponent,
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})
export class BavelAccountModule {
}
